/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as JoinRouteImport } from './routes/join'
import { Route as ParkingRouteImport } from './routes/parking'
import { Route as PeopleRouteImport } from './routes/people'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as TasksIndexRouteImport } from './routes/tasks.index'
import { Route as TasksTaskIdRouteImport } from './routes/tasks.$taskId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const ParkingRoute = ParkingRouteImport.update({
  id: '/parking',
  path: '/parking',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleRoute = PeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/join': typeof JoinRoute
  '/parking': typeof ParkingRoute
  '/people': typeof PeopleRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/join': typeof JoinRoute
  '/parking': typeof ParkingRoute
  '/people': typeof PeopleRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks': typeof TasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/join': typeof JoinRoute
  '/parking': typeof ParkingRoute
  '/people': typeof PeopleRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calendar'
    | '/join'
    | '/parking'
    | '/people'
    | '/events/$eventId'
    | '/tasks/$taskId'
    | '/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/join'
    | '/parking'
    | '/people'
    | '/events/$eventId'
    | '/tasks/$taskId'
    | '/tasks'
  id:
    | '__root__'
    | '/'
    | '/calendar'
    | '/join'
    | '/parking'
    | '/people'
    | '/events/$eventId'
    | '/tasks/$taskId'
    | '/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalendarRoute: typeof CalendarRoute
  JoinRoute: typeof JoinRoute
  ParkingRoute: typeof ParkingRoute
  PeopleRoute: typeof PeopleRoute
  EventsEventIdRoute: typeof EventsEventIdRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  TasksIndexRoute: typeof TasksIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parking': {
      id: '/parking'
      path: '/parking'
      fullPath: '/parking'
      preLoaderRoute: typeof ParkingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people': {
      id: '/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof PeopleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalendarRoute: CalendarRoute,
  JoinRoute: JoinRoute,
  ParkingRoute: ParkingRoute,
  PeopleRoute: PeopleRoute,
  EventsEventIdRoute: EventsEventIdRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  TasksIndexRoute: TasksIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
